<template>
  <div>
    <div v-wechat-title="pcConfig.pageTitle"></div>

    <div
      class="five-anniversary-pc-page"
      :style="bg(pcConfig.pc.bgImage, 'cover')"
    >
      <div
        class="main"
        :style="bg(pcConfig.pc.mainImage, '100% 100%')"
      ></div>
    </div>
  </div>
</template>

<script>
import { getTimeStamp } from "@/utils/utils";
import { mapActions } from "vuex";

const FIVE_MAIN_IMAGE_URL = "https://download4.qcplay.com/snail/five-anniversary/";

const DEFAULT_PC_CONFIG = {
  activityCode: "snail_anniversary_badge",
  periods: 3,
  anniversaryNo: 6,

  pageTitle: "六周年纪念章",

  urls: {
    enter: "/snail/anniversaryBadge/enter"
  },

  pc: {
    /**
     * PC 页面背景图
     * 原 less:
     * background: url('@{mainImageUrl}pc_bg.png')
     */
    bgImage: `${FIVE_MAIN_IMAGE_URL}pc_bg.png`,

    /**
     * PC 页面主体图
     * 原 less:
     * background: url('https://download4.qcplay.com/qcgame-api/lSwbjAhT5i7KHsMEstjMBjtIoDKBrCrCUB4HBKsD.png')
     */
    mainImage: "https://download4.qcplay.com/qcgame-api/lSwbjAhT5i7KHsMEstjMBjtIoDKBrCrCUB4HBKsD.png"
  },

  share: {
    title: "《最强蜗牛》六周年纪念奖章",
    desc: "六周年限定纪念奖章强势来袭！周年专属，错过再等一年！",
    imgUrl: "https://download4.qcplay.com/qcgame-api/7BjM8kVaE5122hic2slbpfCmfvyMjmBWeEoKXtZ3.png"
  }
};

export default {
  name: "anniversaryPc",

  components: {},

  data() {
    return {
      pcConfig: JSON.parse(JSON.stringify(DEFAULT_PC_CONFIG)),
      enterLink: ""
    };
  },

  created() {
    this.loadPcConfig();
  },

  mounted() {
    this.$nextTick(() => {
      const { protocol, host } = window.location;

      const enterPath =
        this.pcConfig.urls.enter || "/snail/anniversaryBadge/enter";

      this.enterLink = `${protocol}//${host}${enterPath}${getTimeStamp()}`;

      this.monitoringEquipment();
      this.isSetShare(this.enterLink);
    });
  },

  computed: {},

  methods: {
    /**
     * 暂时没有后台接口，先使用本地配置。
     * 后续后台接口完成后，只需要替换这个方法。
     */
    loadPcConfig() {
      this.pcConfig = JSON.parse(JSON.stringify(DEFAULT_PC_CONFIG));

      console.log("当前 PC 周年模板配置：", this.pcConfig);
    },

    /**
     * 背景图工具方法
     */
    bg(url, size = "contain") {
      if (!url) return {};

      return {
        background: `url("${url}") center center / ${size} no-repeat`
      };
    },

    /**
     * 移动设备跳转移动端入口
     */
    monitoringEquipment() {
      if (navigator.userAgent.match(/(iPhone|iPod|mobile|Android|ios)/i)) {
        location.href = this.enterLink;
      }
    },

    /**
     * 微信分享
     */
    isSetShare(linkUrl) {
      const share = this.pcConfig.share || {};

      this.setShare({
        link: linkUrl,
        title: share.title,
        imgUrl: share.imgUrl,
        desc: share.desc
      });
    },

    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/anniversaryBadge/pc/index.vue